import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4" }


export default /*@__PURE__*/_defineComponent({
  __name: 'BaseGridLoader',
  props: {
    count: { default: 8 }
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.count, (i) => {
      return (_openBlock(), _createElementBlock("div", {
        key: i,
        class: "skeleton-card"
      }, _cache[0] || (_cache[0] = [
        _createStaticVNode("<div class=\"skeleton-media\" data-v-1139b6f0></div><div class=\"skeleton-body\" data-v-1139b6f0><div class=\"skeleton-line skeleton-line--title\" data-v-1139b6f0></div><div class=\"skeleton-line skeleton-line--meta\" data-v-1139b6f0></div></div><div class=\"skeleton-footer\" data-v-1139b6f0><div class=\"skeleton-line skeleton-line--badge\" data-v-1139b6f0></div><div class=\"skeleton-line skeleton-line--icon\" data-v-1139b6f0></div></div>", 3)
      ])))
    }), 128))
  ]))
}
}

})